__turbopack_context__.v({
  "confirmation": "BvjtZa_confirmation",
  "copyIcon": "BvjtZa_copyIcon",
  "copyToClipboard": "BvjtZa_copyToClipboard",
});
